import { apiFunction } from "../../../apiCalls/function";
import * as APIs from "../../../apiCalls/urls/officer/urls";


export const addVcReport = async (data) => {
    return await apiFunction(APIs.ADD_VC_IMG, "post", data, true, "admin")
}
